import axios from "axios";

const BASE = () => process.env.REACT_APP_BACKEND_URL || "";

export async function listOrganizations({
  limit = 50,
  exclusiveStartKey = null,
} = {}) {
  const res = await axios.post(BASE() + "admin/organizations", {
    limit,
    exclusiveStartKey,
  });
  return res.data;
}

export async function setLockoutOverride({
  orgId,
  isActive,
  expiration,
  reason,
}) {
  const res = await axios.post(BASE() + "admin/organizations/lockout-override", {
    orgId,
    isActive,
    expiration,
    reason,
  });
  return res.data;
}

export async function setTrialEnd({ orgId, trialExpiresAt }) {
  const res = await axios.post(BASE() + "admin/organizations/trial-end", {
    orgId,
    trialExpiresAt,
  });
  return res.data;
}

export async function getOrganizationDetail(orgId) {
  const res = await axios.post(BASE() + "admin/organizations/detail", {
    orgId,
  });
  return res.data;
}

export async function getOrganizationTwilio(
  orgId,
  { refreshTrial = false } = {}
) {
  const res = await axios.post(BASE() + "admin/organizations/twilio", {
    orgId,
    refreshTrial,
  });
  return res.data;
}

export async function updateTwilioVoiceUrl({
  orgId,
  phone_number,
  webhook_url,
}) {
  const res = await axios.post(
    BASE() + "admin/organizations/twilio/update-voice-url",
    { orgId, phone_number, webhook_url }
  );
  return res.data;
}

export async function generateTwilioApplicationDetails(body) {
  const res = await axios.post(
    BASE() + "admin/organizations/twilio/generate-application-details",
    body
  );
  return res.data;
}

export async function createActivity({
  orgId,
  action = "note",
  category = "note",
  summary,
  body,
  metadata,
}) {
  const res = await axios.post(BASE() + "admin/activity", {
    orgId,
    action,
    category,
    summary,
    body,
    metadata,
  });
  return res.data;
}

export async function queryActivity({
  orgId,
  limit = 50,
  from,
  to,
  category,
  exclusiveStartKey = null,
} = {}) {
  const res = await axios.post(BASE() + "admin/activity/query", {
    orgId,
    limit,
    from,
    to,
    category,
    exclusiveStartKey,
  });
  return res.data;
}

export async function impersonate({ userId, email, reason }) {
  const payload = { reason };
  if (userId) payload.userId = userId;
  if (email) payload.email = email;
  const res = await axios.post(BASE() + "admin/impersonate", payload);
  return res.data;
}
